import { createApp } from 'vue';
import FlyoverVideos from './FlyoverVideos.vue';

function mountFlyoverVideosApp(elementId: string) {
  const el = document.getElementById(elementId);
  if (!el) return;

  // The public-profile mount passes { context: 'public', firebaseUserId } via a
  // data-app-config attribute; the logged-in user's own page passes nothing and
  // defaults to the 'current' context (where deletion is allowed).
  let config: { context?: string; firebaseUserId?: string; publicDisplayName?: string } = {};
  try {
    config = JSON.parse(el.dataset.appConfig || '{}');
  } catch (_) {
    config = {};
  }

  const app = createApp(FlyoverVideos, {
    context: config.context || 'current',
    firebaseUserId: config.firebaseUserId || null,
    publicDisplayName: config.publicDisplayName || null,
  });
  app.mount(`#${elementId}`);
}

if (document.getElementById('flyover-videos-app')) {
  mountFlyoverVideosApp('flyover-videos-app');
}
